module.exports = "/assets/217b01e6e2bb85d222beee98bb75c01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KC.png
// module id = 2664
// module chunks = 0